export default "__VITE_ASSET__oPx6iAfZ__"